import Iframe from "react-iframe";
import useCollapse from "react-collapsed";
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
var element = "https://element.gomybiz.net/";
export default function Chat(props) {
  var lienelment = "";
  if (props.location.state != undefined) {
    var element = props.location.state.fromDashboard;
    var lienelment = `https://element.gomybiz.net/#/user/@${element}:gomybiz.net?action=chat`;
    const lienelment2 =
      "https://element.gomybiz.net/#/room/!hvHVipmFQpDaznRrls:gomybiz.net";
  } else {
    var element =
      "https://element.gomybiz.net/#/room/!hvHVipmFQpDaznRrls:gomybiz.net";
  }
  if (
    element ==
    "https://element.gomybiz.net/#/room/!hvHVipmFQpDaznRrls:gomybiz.net"
  ) {
    return (
      <div className="content pb-4 flex flex-col h-screen dark:bg-gray-800 dark:text-white transition-al">
        <Iframe
          id="iframedoc"
          url="https://element.gomybiz.net/#/room/!hvHVipmFQpDaznRrls:gomybiz.net"
          // url="https://element.gomybiz.net"
          allow="camera;microphone"
          className=""
          height="100%"
          width="100%"
        />
      </div>
    );
  } else
    return (
      <div className="content pb-4 flex flex-col h-screen dark:bg-gray-800 dark:text-white transition-al">
        <Iframe
          id="iframedoc"
          url={lienelment}
          // url="https://element.gomybiz.net"
          allow="camera;microphone"
          className=""
          height="100%"
          width="100%"
        />
      </div>
    );
}
